module.exports = __webpack_public_path__ + "static/media/add-folder.d7fa9aae.svg";